export default __webpack_public_path__ + "static/media/franchise-management-2.ec0948cb.svg";